<template>
  <van-field
    v-model="value"
    :type="type"
    :readonly="readonly"
    :maxlength="maxlength"
    :placeholder="placeholder"
    clearable
    class="input-field"
    @input="handleChange"
  >
    <template slot="right-icon">
      <div class="right">
        <slot name="right">
          <van-icon v-if="readonly" name="arrow" class="arrow" />
        </slot>
      </div>
    </template>
  </van-field>
</template>
<script>
export default {
  props: {
    placeholder: [String],
    type: {
      type: String,
      default: 'text',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    setValue(val) {
      this.value = val;
    },
    handleChange(val) {
      this.$emit('change', val);
    },
  },
};
</script>
<style lang="less" scoped>
.input-field {
  &::after {
    border: none;
  }
  .right {
    color: #faad14;
    .arrow {
      color: #969799;
    }
  }
}
</style>
